import ShipmentsCard from '@/components/Shipping/ShipmentsCard';
import { useRecordId } from '@/utils/genericResource';

export default function OrderShipmentsCard({ showActions }: { showActions?: boolean }) {
  const orderId = Number(useRecordId());
  return <ShipmentsCard shippableId={orderId} shippableType="order" showActions={showActions} />;
}
